import React from 'react'
import './faq.css'

const Faq = () => {
  return (
 <div>
    <h3 className='heading'>FAQ</h3>
    <div class="faq-content-wrapper">

      <div class="faq">
        <h2>What should I do, if I want to visit your office to see activities?</h2>
        <p>
          You may write an application mentioning (1) Your brief introduction with full contact information
          (2) Purpose (3) Date & Time of visit (4) Number of persons in a group (5) If you are a foreigner, also
          attach copies of your Passport and Visa ; Send it by Post/ Fax/Email addressing to this Office. Your
          applications should reach us well in advance. Only after receiving the authentication letter from the
          concerned office, you may proceed to visit to see activities.
          However, every year on the event of National Science Day i.e. 28 February, Survey of India
          Offices observes Open House to show its activities to the general public.</p>
      </div>
      <div class="faq">
        <h2>How can I apply for Summer / Winter Internship/college students visits, in NIGST?</h2>
        <p>
          As per policy SOI do not entertain any application being sent by a student directly for
          Summer/Winter internship/Student visits.
          Applications forwarded by the Head of Institutions with duly recommendation of the name(s) of
          their student(s) for Summer/Winter internship/visits on their official letterheads to the Additional
          Surveyor General, NIGST, are considered. Your applications should reach us well in advance No
          financial matter (i.e. pay or stipend) involves.
        </p>
      </div>
      <div class="faq">
        <h2> I have done a professional course conducted at NIGST, how can I serve in Survey of India?</h2>
        <p>
          Qualifying in the professional courses conducted at NIGST, Survey of India, Uppal,
          Hyderabad does not mean that you have right to serve in Survey of India. You can keep looking for
          advertisement in the National Newspapers as well as Survey of India website, whenever vacancies are
          advertised, you may apply as per laid down procedure.
        </p>
      </div>
      <div class="faq">
        <h2>When is the right time to apply for any course?</h2>
        <p>
          Nomination / Application for admission to a course should reach the Addl Surveyor
          General, NIGST, normally 60 days before the scheduled date of commencement of the
          Course. Trainees are advised to report in the Institute only on receiving confirmation
          about the allotment of seat.
        </p>
      </div>
      <div class="faq">
        <h2>Is hostel facility available in the institute, in case I apply for long term courses?</h2>
        <p>
          Hostel facility is available in the institute. Requirement of Hostel Accommodation
          need to be intimated to the Additional Surveyor General, NIGST(Attention: Hostel
          Warden), sufficiently in advance through separate letter. Boarding and Lodging expenses
          for a trainee has to be paid separately in addition to the tuition fee.
        </p>
      </div>
      <div class="faq">
        <h2>Does NIGST assists in any placements for the trainees after the completion of the course?</h2>
        <p>
          No.
        </p>
      </div>
    </div>
    </div>
   
  )
}

export default Faq